import { RentalInfoForm } from "shared/app/RentalInfoForm";
import { useUnitFormContext } from "../UnitFormProvider";
import { UnitGeneralForm } from "../../UnitGeneralForm";
import { PlanForm } from "shared/app/PlanForm";
import { AmenitiesForm } from "shared/app/AmenitiesForm";
import { PhotosForm } from "shared/app/PhotosForm";
import { PropertyKind } from "shared/types";
import { Show } from "shared/components";

interface CreateUnitFormProps {
  propertyKind?: PropertyKind | null;
}

export const CreateUnitForm = ({ propertyKind }: CreateUnitFormProps) => {
  const {
    handleSubmit,
    register,
    values,
    handleChange,
    sessionKey,
    setPhotosUploading
  } = useUnitFormContext();

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-[822px]">
      <UnitGeneralForm register={register} propertyKind={propertyKind} />
      <RentalInfoForm register={register} />
      <Show if={propertyKind}>
        <PlanForm register={register} />
        <AmenitiesForm
          isUnit
          register={register}
          selectedAmenities={values.amenities}
          level="unit"
        />
        <PhotosForm
          onChange={(formattedPhotos) => handleChange("media")(formattedPhotos)}
          sessionKey={sessionKey}
          setPhotosUploading={setPhotosUploading}
        />
      </Show>
    </form>
  );
};
